export default __webpack_public_path__ + "static/media/Templately.47c7ab6c.svg";